import React,{useState,useEffect} from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Hidden from '@mui/material/Hidden';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import {Tools} from './Tools';
import {Inc,Item,Owner,Dataset} from './Inc';
import useStyles from './Styles';
import ColInput from './ColInput';
import ItemLabelIcon from './ItemLabelIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Theme} from './Theme';

interface ItemLabelConfirmProps {
	isOpen:boolean,
    items:Item[],
	labelId:number,
	label:string,
	finish(): void,
    close(): void,
}

const ItemLabelConfirm = (props:ItemLabelConfirmProps)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

	const finish = ()=>{
		props.finish();
    }

	useEffect(()=>{
		if(props.isOpen){

		}
	},[props.isOpen])

	if(!props.isOpen){
		return (null);
	}

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			maxWidth='md'
			fullWidth={true}
			fullScreen={fullScreen}
		>
			<DialogTitle color="primary">ラベル設定の確認</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide} style={{display:"flex",gap:"0.5em"}}>
					<div style={{display:"flex", alignItems:"center",gap:"0.25em",border:"1px solid black", padding:"0 0.5em"}}><ItemLabelIcon labelId={props.labelId}/><span style={{marginLeft:"0.25em"}}>{props.label}</span></div>
					のラベルをつける商品に間違いがなければ「決定」を押して下さい。 <br/>
				</div>
				<div style={{marginBottom:"2em"}}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell className={classes.tableHeadNowrap} align='center'>商品</TableCell>
								<TableCell className={classes.tableHeadNowrap} align='center'>在庫</TableCell>
								<Hidden smDown implementation="js">
								<TableCell className={classes.tableHeadNowrap} align='center'>状態表示</TableCell>
								</Hidden>
							</TableRow>
						</TableHead>
						<TableBody>
					{props.items.map( (item:Item,index:number)=>{
						const key = "item"+index;
						return (
							<TableRow key={key}>
								<TableCell className={classes.tableCellDense}>
									<span className={classes.itemId}>ID:{item.item_id}</span>　
									<Hidden smUp implementation="js">
										<br/>
									</Hidden>
									{item.item_name}
								</TableCell>
								<TableCell className={classes.tableCellNowrap} align="center" style={{width:'3rem'}}>
									{item.num_stock}
								</TableCell>
								<Hidden smDown implementation="js">
								<TableCell align="center" style={{width:'6rem'}}>
									{Tools.colorLabel("item_status",item.status,item.status_label)}
								</TableCell>
								</Hidden>
							</TableRow>
						);
					})}
						</TableBody>
					</Table>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='決定' onClick1={finish} disabled1={false} button2='選びなおす' onClick2={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default ItemLabelConfirm;
